import { DeleteOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Checkbox, Form, Input, List, Select, Tooltip } from 'antd';
import { comboColorMap, ORIENTATION_OPTIONS, POSTER_LANGUAGE_OPTIONS } from 'constants/constant';
import React from 'react';
import { PosterInterface } from 'type/seasonType';

interface PosterListProps {
  posters: PosterInterface[];
  selectedPoster: PosterInterface | null;
  onPosterSelect: (poster: PosterInterface | null) => void;
  onPosterRemove: (poster: PosterInterface) => void;
  onPosterChange: (poster: PosterInterface, key: string, value: string) => void;
  onNewPosterChange: (poster: PosterInterface, key: string, value: string) => void;
  canDownload?: boolean;
  isNew?: boolean;
}

const PosterList: React.FC<PosterListProps> = ({
  posters,
  selectedPoster,
  onPosterSelect,
  onPosterRemove,
  onPosterChange,
  onNewPosterChange,
  canDownload,
  isNew,
}) => {
  return (
    <List
      itemLayout="vertical"
      dataSource={posters}
      renderItem={(poster: PosterInterface) => {
        const key = `${poster.language}-${poster.orientation}`;
        const bgColor = comboColorMap[key] || 'transparent';

        return (
          <Card className="upload-video-list-item" hoverable style={{ backgroundColor: bgColor }}>
            <div className="video-meta">
              <Form.Item>
                <Checkbox
                  checked={selectedPoster?.id === poster.id}
                  onChange={e => {
                    if (e.target.checked) {
                      onPosterSelect(poster);
                    } else {
                      onPosterSelect(null);
                    }
                  }}
                />
              </Form.Item>
              <Avatar
                shape="square"
                style={{
                  width: '100px',
                  height: '100px',
                  paddingLeft: '10px',
                }}
                src={poster.file ? poster.file : ''}
              />
              <div className="video-info">
                <Form.Item label="Name">
                  {canDownload ? (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                      }}
                    >
                      <Tooltip title={poster.file?.split('/').pop()}>
                        <span
                          className="poster-file-name"
                          style={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'inline-block',
                            maxWidth: '300px',
                            verticalAlign: 'middle',
                          }}
                        >
                          {poster.file?.split('/').pop()}
                        </span>
                      </Tooltip>
                    </div>
                  ) : (
                    <Input type="text" value={poster.file || ''} />
                  )}
                  <Form.Item label="Language">
                    <Select
                      value={poster.language}
                      onChange={(value: string) =>
                        isNew
                          ? onNewPosterChange(poster, 'language', value)
                          : onPosterChange(poster, 'language', value)
                      }
                      style={{ width: 170 }}
                      options={POSTER_LANGUAGE_OPTIONS}
                    ></Select>
                  </Form.Item>

                  <Form.Item label="Orientation">
                    <Select
                      value={poster.orientation}
                      onChange={(value: string) =>
                        isNew
                          ? onNewPosterChange(poster, 'orientation', value)
                          : onPosterChange(poster, 'orientation', value)
                      }
                      style={{ width: 120 }}
                      options={ORIENTATION_OPTIONS}
                    ></Select>
                  </Form.Item>
                </Form.Item>
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={() => onPosterRemove(poster)}
                >
                  delete
                </Button>
              </div>
            </div>
          </Card>
        );
      }}
    />
  );
};

export default PosterList;
